import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  Container,
  Form,
  FormFeedback,
  UncontrolledAlert,

  Spinner // Import Spinner component for loading indicator
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { post } from "../../Services/RestAPIService";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { withTranslation } from 'react-i18next';

const CreateCategory = ({ t }) => {
  const [categoryImage, setCategoryImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // State to track loading status
  const navigate = useNavigate();

  const [alert, setAlert] = useState({
    color: "",
    message: "",
    visible: false,
    strongM: ""
  });

  const validation = useFormik({
    initialValues: {
      name: "",
      description: "",
      image: ""
    },

    validationSchema: Yup.object({
      name: Yup.string().required(t("Please Enter Category Name")),
      description: Yup.string().required(t("Please Enter Description")),
      //   image: Yup.mixed().test("file", t("Please select an image file"), file => file && file.type.includes("image/"))
    }),


    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);

      const data = {
        name: values.name,
        description: values.description,
        image: categoryImage
      };

      try {
        const response = await post("category/categories/", data, {
          headers: { "Content-Type": "application/json" },
          validateStatus: false
        });
        console.log(response)

        if (response.status !== 400) {
          setAlert({
            color: "success",
            visible: true,
            message: t("New category created successfully! Re-directing to Add Body Parts"),
            strongM: t("Success!")
          });
          setTimeout(() => {
            setAlert({ visible: false });
          }, 3000);

          setTimeout(() => {
            navigate(`/category/sub-category/${response.data.id}`)
          }, 2000);

          validation.setValues(validation.initialValues);
          validation.setErrors({});
          resetForm(); // Reset the form
          setCategoryImage(null);
         
        

        } else {
          let errorMessage = t("An error occurred while updating category data.");
          for (const key in response.data) {
            if (Array.isArray(response.data[key]) && response.data[key].length > 0) {
              errorMessage = `${key}: ${response.data[key][0]}`;
              break;
            }
          }
          setAlert({
            color: "danger",
            visible: true,
            message: errorMessage,
            strongM: t("Error!")
          });
          setTimeout(() => {
            setAlert({ visible: false });
          }, 3000);
        }
      } catch (error) {
        let errorMessage = t("An error occurred while updating category data.");
        console.error('Error creating category:', errorMessage, error);
        setAlert({
          color: "danger",
          visible: true,
          message: errorMessage,
          strongM: t("Error!")
        });
        setTimeout(() => {
          setAlert({ visible: false });
        }, 3000);
      } finally {
        setIsLoading(false);
      }
    }
  })


  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setCategoryImage(base64String); // Assuming setProfileImage is a state setter function
      };
      reader.readAsDataURL(file);
    }
  };



  return (
    <React.Fragment>
      {alert.visible && <UncontrolledAlert className="Alert_Additions_Log" color={`${alert.color || "warning"}`} role="alert">
        {alert?.message || "Welcome"}
      </UncontrolledAlert>}

      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs maintitle={t("Home")} title={t("Pain Area's")} titleLink="/category" breadcrumbItem={t("Create Pain Area")} />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <CardTitle>{t("Create New Pain Area")}</CardTitle>
                  <CardSubtitle className="mb-3">
                    {t("You can create a new Pain Area from here.")}
                  </CardSubtitle>
                  <Form onSubmit={validation.handleSubmit}>
                    <div className="mb-3">
                      <Label className="form-label">{t("Pain Area Name")}</Label>
                      <Input
                        type="text"
                        name="name"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ""}
                        invalid={validation.touched.name && validation.errors.name}
                      />
                      {validation.touched.name && validation.errors.name && (
                        <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                      )}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">{t("Description")}</Label>
                      <Input
                        type="textarea"
                        name="description"
                        rows="5"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.description || ""}
                        invalid={validation.touched.description && validation.errors.description}
                      />
                      {validation.touched.description && validation.errors.description && (
                        <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                      )}
                    </div>

                    <div className="mb-3">
                      <Label className="form-label">{t("Image")}</Label>
                      <Input
                        type="file"
                        name="image"
                        onChange={handleImageChange}
                      />
                    </div>

                    <div className="d-flex flex-wrap gap-2">


                      <Button type="submit" color="primary" disabled={isLoading}>
                        {isLoading ? (
                          <Spinner size="sm" color="light" />
                        ) : (
                          `${t("Create")}`
                        )}
                      </Button>{" "}


                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(CreateCategory);
